import withApollo from 'next-with-apollo';
import createApolloClient from './apolloClient';

export default withApollo(({ ctx, initialState }) => {
  console.log(`Creating apollo client for GIP`);
  return createApolloClient(ctx, initialState);
});
